import React from 'react';
import { createPortal } from 'react-dom';

import classes from './EditorViewer.module.css';

class FramePortal extends React.PureComponent {
  containerEl: HTMLDivElement;
  style: HTMLStyleElement;
  css: string;
  onClick: any;
  iframe: HTMLIFrameElement;
  constructor(props) {
    super(props);
    this.containerEl = document.createElement('div');
    this.containerEl.id = 'root';
    this.style = document.createElement('style');
    this.css = `
            @import url('https://fonts.googleapis.com/css?family=Montserrat');
            @import url('https://use.fontawesome.com/releases/v5.4.2/css/all.css');
            @import url('https://cdn.jsdelivr.net/npm/pretty-checkbox@3.0/dist/pretty-checkbox.min.css');

            @font-face {
                font-family: 'Consolas';
                font-style: normal;
                font-weight: normal;
                src: url('fonts/Consolas.woff') format('woff'), url('fonts/Consolas.ttf') format('truetype');
            }

            #logger {
                top: 6%;
                left: 6%;
                width: 88%;
                height: 44%;
                z-index : 1000;
                position: absolute;
                background-color: #FFF;
                color: #000;
                opacity: 0.50;
                outline: none;
                padding: 0;
                border: 0;
                display: none;
                white-space: pre;
            }

            input:focus {
                outline: none;
            }

            div:focus {
                outline: none;
            }

            .noselect {
                -webkit-touch-callout: none;
                /* iOS Safari */
                -webkit-user-select: none;
                /* Safari */
                -khtml-user-select: none;
                /* Konqueror HTML */
                -moz-user-select: none;
                /* Firefox */
                -ms-user-select: none;
                /* Internet Explorer/Edge */
                user-select: none;
                /* Non-prefixed version, currently
                                            supported by Chrome and Opera */
            }

            html {
                background-color: #000;
                color: #e3e3e3;
                font-family: 'Montserrat', sans-serif;
                font-size: 1em;
                font-weight: 500;
                line-height: 1.15;
                -webkit-font-smoothing: antialiased;
            }

            div {
                -moz-box-sizing: border-box;
                -webkit-box-sizing: border-box;
                box-sizing: border-box;
                }
                *, *:before, *:after {
                    box-sizing: border-box;
                }
                div {
                    display: block;
                }

            ::-moz-selection {
                background: #fcea67;
                color: #141414;
                text-shadow: none;
            }

            ::selection {
                background: #fcea67;
                color: #141414;
                text-shadow: none;
            }

            hr {
                border: 0;
                border-top: 1px solid #a2a2a230;
                display: block;
                height: 1px;
                margin: 1em 0;
                padding: 0;
            }

            #root,
            body,
            html {
                height: 100%;
                margin: 0;
                user-select: none;
                width: 100%;
                overflow:hidden;
            }

            /* logo */
            .logo-meta {
                height: 3em;
                left: 1em;
                position: absolute;
                top: 1em;
                /* width: 3em; */
            }
            html, body {
                padding: 0;
                margin: 0;
                height:100%;
                width:100%;
                overflow:hidden;
            }
            canvas {
                width: 100%;
                height: 100%;
                position: absolute;
            }

            canvas:focus {
                outline: none;
            }

            body {
                overscroll-behavior-y: none;
            }
        `;

    this.style.innerHTML = this.css;

    this.onClick = props.onClick;
  }

  render() {
    return (
      <iframe
        tabIndex={0}
        className={classes.iframe}
        style={{ border: '0' }}
        title="iframe"
        ref={(el) => (this.iframe = el)}
        // {...this.props}
      >
        {createPortal(this.props.children, this.containerEl)}
      </iframe>
    );
  }

  componentDidMount() {
    this.iframe.contentDocument.head.appendChild(this.style);
    this.iframe.contentDocument.body.appendChild(this.containerEl);
    if (this.onClick)
      this.iframe.contentWindow.addEventListener('click', this.onClick, true);
  }
}

export default FramePortal;
